//Initialize sandbox
AAcom('utilities', 'loyaltyInformation', function (AAUI) {

    const _busyFormSubmit = AAUI.getProperty('busyProcessing');
    const _formID = AAUI.getProperty('formID');

    AAUI.initPageSubmit = function() {
        AAUI.onSubmit(_formID, function() {
            if ($j(_formID).aaBusy({
                message: _busyFormSubmit
            }).start());
        });
    };

    AAUI.initPage = function(pageLoad) {
        pageLoad = pageLoad || false;
        if (pageLoad) {
            AAUI.initSecurityQuestionsForm();
            AAUI.initPageSubmit();
        }
    };

    $j(document).ready(function() {
        AAUI.initPage(true);
    });
});
